import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'GlampingPopularDestinations',
  setup(__props) {

const POPULAR_DESTINATIONS = [
  {
    name: 'Scotland',
    url: '/glamping/Scotland/',
    imgUrl: require('@/assets/popular-searches/scotland.jpg'),
  },
  {
    name: 'Wales',
    url: '/glamping/Wales/',
    imgUrl: require('@/assets/popular-searches/wales.jpg'),
  },
  {
    name: 'Cornwall',
    url: '/glamping/England/South_West/Cornwall/',
    imgUrl: require('@/assets/popular-searches/cornwall.jpg'),
  },
  {
    name: 'Norfolk',
    url: '/glamping/England/East_Anglia/Norfolk/',
    imgUrl: require('@/assets/popular-searches/norfolk.jpg'),
  },
  {
    name: 'New Forest',
    url: '/glamping/England/South_East/Hampshire/Fritham/',
    imgUrl: require('@/assets/popular-searches/new-forest.jpg'),
  },
  {
    name: 'Devon',
    url: '/glamping/England/South_West/Devon/',
    imgUrl: require('@/assets/popular-searches/devon.jpg'),
  },
  {
    name: 'Northumberland',
    url: '/glamping/England/North_East/Northumberland/',
    imgUrl: require('@/assets/popular-searches/northumberland.jpg'),
  },
  {
    name: 'The Lake District and Cumbria',
    url: '/glamping/England/North_West/Cumbria/',
    imgUrl: require('@/assets/popular-searches/lake-district.jpg'),
  },
  {
    name: 'North Yorkshire',
    url: '/glamping/England/North_East/North_Yorkshire/',
    imgUrl: require('@/assets/popular-searches/north-yorkshire.jpg'),
  },
  {
    name: 'Northern Ireland',
    url: '/glamping/Northern_Ireland/',
    imgUrl: require('@/assets/popular-searches/northern-ireland.jpg'),
  },
  {
    name: 'The Peak District',
    url: '/glamping/England/Central/Derbyshire/tideswell/',
    imgUrl: require('@/assets/popular-searches/peak-district.jpg'),
  },
].map((d) => {
  return {
    ...d,
    to: {
      hierarchyPath: d.url.replace('/glamping/', ''),
      category: 'glamping',
    },
    label: d.name,
    imgUrl: d.imgUrl
      ? d.imgUrl
      : require('@/assets/popular-searches/lake-district.jpg'),
    isLCP: false,
    displayOrder: d.displayOrder || 0,
  }
})

return { __sfc: true,POPULAR_DESTINATIONS }
}

})